<template>
    <v-container>
        <!-- <loader :loading="isloading"></loader> -->
        <v-card shaped class="mx-4 my-4 pa-4">
            <v-row>
                <v-col cols="12">
                    <v-toolbar
                        flat
                        color="#1d2735"
                        dark
                        style="border-radius: 5px"
                    >
                        <v-icon class="white--text" style="font-size: 45px"
                            >mdi-account-supervisor-circle</v-icon
                        >
                        <pre><v-toolbar-title><h2>Calendario Seguimientos</h2></v-toolbar-title></pre>
                    </v-toolbar>

                    <!-- <v-form class="mt-3"> </v-form> -->
                </v-col>
            </v-row>

            <div class="d-flex align-items-center">
                <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            :to="{ path: `/lista-seguimiento` }"
                            :loading="isloading"
                            :disabled="isloading"
                            color="primary darken-1"
                            class="mt-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon class="white--text"
                                >mdi-format-list-bulleted</v-icon
                            >
                        </v-btn>
                    </template>
                    <span>Listado de seguimientos</span>
                </v-tooltip>
                <v-autocomplete
                    v-if="role == 1 || role == 5"
                    v-model="id_vendedor"
                    :items="empleados"
                    item-text="nombre"
                    item-value="id"
                    label="Vendedor"
                    outlined
                    dense
                    clearable
                    class="mt-4 ml-4 col-10 col-md-4"
                ></v-autocomplete>
            </div>
            <v-row>
                <v-col cols="12">
                    <cita-picker
                        :potencial="$route.meta.potencial"
                        @CambioFecha="CambioFecha"
                        v-model="Seguimientos"
                        :loading.sync="isloading"
                    ></cita-picker>
                </v-col>
            </v-row>
        </v-card>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            isloading: false,
            rol: 0,
            id_vendedor: null,
            clientes: [],
            seguimiento: {},
            agentes: {},
            Seguimientos: [],
            controles: [],
            acciones: [],
            productos: [],
            empleados: [],
            startDate: "",
            endDate: "",
        };
    },
    created() {
        // this.getSeguimientos();
        this.loadFiltros();
        this.getEmpleados();
    },
    methods: {
        CambioFecha(week) {
            if (week.length >= 7) this.getSeguimientos(week[0], week[6]);
        },
        getSeguimientos(desde, hasta) {
            const self = this;
            self.isloading = true;
            self.startDate = desde;
            self.endDate = hasta;

            let params = {
                desde: desde,
                hasta: hasta,
            };
            if (this.role == 1 || this.role == 5) {
                params.id_vendedor = this.id_vendedor;
            }
            if (this.$route.meta.potencial) {
                params.potencial_only = true;
            } else {
                params.cliente_only = true;
            }
            axios
                .get(`api/get-tareas-unicas-proyecto`, {
                    params: params,
                })
                .then(
                    (res) => {
                        self.Seguimientos = res.data;
                        self.isloading = false;
                    },
                    (err) => {
                        this.$toast.error("Error consultando Seguimientos");
                    }
                );
        },
        formatNumber(number) {
            return Number.parseFloat(number.toString())
                .toFixed(2)
                .replace(".", ",")
                .replace(",00", "");
        },
        getEmpleados() {
            axios.post("api/get-usuarios-empleados-all").then((res) => {
                this.empleados = res.data.users;
            });
        },

        // Metodos auxiliares
        // Guardar filtros
        saveFiltros(bool, item) {
            const filtros_modulo = this.$store.getters.get_filtros
                .seguimiento || {
                filtros: {},
            };

            if (bool) {
                filtros_modulo.filtros = {
                    ...filtros_modulo.filtros,
                    ...item,
                };
            }

            this.$store.dispatch("setFiltros", {
                name: "seguimiento",
                filtros: filtros_modulo,
            });
        },
        loadFiltros() {
            const filtros_modulo = this.$store.getters.get_filtros.seguimiento;

            if (filtros_modulo && filtros_modulo.filtros) {
                this.id_vendedor = filtros_modulo.filtros.id_vendedor;
            }
        },
    },
    filters: {},
    watch: {
        id_vendedor(newVal) {
            this.saveFiltros(true, { id_vendedor: newVal });
            this.getSeguimientos(this.startDate, this.endDate);
        },
    },
    computed: {
        ...mapGetters({
            userRole: 'auth/userRole'
        }),
        // isloading() {
        //     return this.$store.getters.getloading;
        // },
        provincias() {
            return this.$store.getters.getprovincias;
        },
        role: function () {
            return this.userRole;
        },
    },
};
</script>
<style>
.rowtwo {
    display: flex;
    flex-direction: row;
}
.spacing {
    padding-top: 0 !important;
}
</style>
